import { createDeepEqual } from '@stytch/core';

export const deepEqual = createDeepEqual();
